import { render, staticRenderFns } from "./DocCommandes.vue?vue&type=template&id=fde62628&"
import script from "./DocCommandes.vue?vue&type=script&lang=js&"
export * from "./DocCommandes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports